


































import { Relance } from "../../models/Relance";
import AssignCoproprieteModal from "./AssignCoproprieteModal.vue";
import { Contact } from "../../models/Contact";

export default {
    name: "FactureRow",
    components: {
        AssignCoproprieteModal,
    },
    props: {
        facture: Relance,
    },
    data() {
        return {
            showAssignModal: false,
        };
    },
    methods: {
        roundAmount(amount) {
            return _.round(amount, 2).toFixed(2);
        },
        openAssignModal() {
            this.showAssignModal = true;
        },
        closeAssignModal() {
            this.showAssignModal = false;
        },
        onClientAssigned(client: Contact) {
            // Assign the selected client to the facture
            this.facture.copropriete = client;
            this.showAssignModal = false;

            // Emit event to parent component to handle the assignment
            this.$emit("client-assigned", {
                facture: this.facture,
                client: client,
            });
        },
    },
};
